<template>
  <div class="card-feedback">
    <div
      class="feeback-icon"
      :class="isSuccess ? 'feeback-icon-success' : 'feeback-icon-error'"
    >
      <img
        src="../../public/img/check-solid.svg"
        v-if="isSuccess"
        style="width: 50px"
      />
      <img src="../../public/img/times-solid.svg" v-else style="width: 50px" />
    </div>
    <div class="feedback-text" v-if="isSuccess">
      <p style="font-weight: 600">{{ messageSuccessTitle }}</p>
      <p>{{ messageSuccessBody }}</p>
      <p v-if="!message">Aguarde na recepção e será encaminhado em breve.</p>
    </div>
    <div class="feedback-text" v-else-if="!isSuccess">
      <p
        style="width: 75%; margin-bottom: 8px"
        v-for="(message, index) in messageError"
        :key="index"
      >
        {{ message }}.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      messageList: [],
    };
  },
  props: ["isSuccess", "message"],
  computed: {
    messageSuccessTitle() {
      if (this.message && this.message.title) {
        return this.message.title;
      } else {
        return "QR Code lido com sucesso!";
      }
    },
    messageSuccessBody() {
      if (this.message && this.message.body) {
        return this.message.body;
      } else {
        return "Os responsáveis serão notificados em instantes.";
      }
    },
    messageError() {
      if (this.message) {
        const list = this.message.split(".");
        this.messageList = list;
        return this.messageList.filter((msg) => msg.trim() !== "");
      } else {
        return "Não foi possível validar o QR Code.";
      }
    },
  },
};
</script>

<style scoped>
.card-feedback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  /* max-width: 500px;
  min-width: 500px; */
  height: 250px;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  position: relative;
  margin-top: 30px;
}

.feeback-icon {
  width: 100px;
  height: 100px;
  /* background-image: url('../../public/img/icons/success.svg');
  background-size: cover;
  background-position: center; */
  /* background-color: green; */
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -40px;
}

.feeback-icon-success {
  background-color: green;
}

.feeback-icon-error {
  background-color: rgb(160, 19, 19);
}

.feedback-text {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  text-align: center;
  gap: 3px;
  /* position: absolute;
  top: 200px; */
  p {
    color: black !important;
    /* width: 100%; */
  }
}
</style>
